interface PlayModalProps {
  open: boolean;
  title: string;
  onClose: () => void;
}

export default function PlayModal({ open, title, onClose }: PlayModalProps) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-primary-950/70 p-4 animate-fade-in"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md rounded-lg bg-background-50 p-6 text-center"
        onClick={(e) => e.stopPropagation()}
      >
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-accent-100 text-accent-600">
          <i className="ri-play-circle-line text-3xl"></i>
        </span>
        <h3 className="mt-4 text-lg font-bold text-foreground-950">播放功能为演示状态</h3>
        <p className="mt-2 text-sm leading-relaxed text-foreground-600">
          《{title}》的在线播放功能当前为前端演示，正式播放接口待接入。
          演示期间不会真正加载视频资源，感谢你的理解。
        </p>
        <button
          type="button"
          onClick={onClose}
          className="mt-6 w-full rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
        >
          我知道了
        </button>
      </div>
    </div>
  );
}